import React, { useEffect } from 'react';
import { Typography, AppBar, Toolbar } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useState } from "react";
import { auth } from "./firebase";

export default function NavBar() {
    const [usr, setUsr] = useState('Log In');
    const [logged, setLogged] = useState('/login');

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(function (user) {
            if (user) {
                setUsr(`Welcome, ${user.displayName}!`);
                setLogged('/profile');
            } else {
                setUsr('Log in');
                setLogged('/login');
            }
        });

        // Cleanup the subscription when the component unmounts
        return () => unsubscribe();
    }, []);

    return (
        <AppBar position="static" style={{ background: '#003c6c', minHeight: '80px' }}>
            <Toolbar>
                {/* Link components for navigation */}
                <Typography variant="h6" component="div" sx={{ flexGrow: 1, marginTop: '10px' }}>
                    <RouterLink to="/" style={{ textDecoration: 'none', color: 'inherit', fontSize: '1.7rem' }}>
                        OnTime
                    </RouterLink>
                </Typography>

                {/* Menu items as part of the navbar */}
                <RouterLink to="/" style={{ textDecoration: 'none', color: 'inherit', fontSize: '1.2rem', marginRight: '17px', marginTop: '10px' }}>
                    Home
                </RouterLink>
                <RouterLink to="/about" style={{ textDecoration: 'none', color: 'inherit', fontSize: '1.2rem', marginRight: '17px', marginTop: '10px' }}>
                    About Us
                </RouterLink>
                <RouterLink to="/resources" style={{ textDecoration: 'none', color: 'inherit', fontSize: '1.2rem', marginRight: '17px', marginTop: '10px' }}>
                    Resources
                </RouterLink>
                <RouterLink to="/help" style={{ textDecoration: 'none', color: 'inherit', fontSize: '1.2rem', marginRight: '17px', marginTop: '10px' }}>
                    Help
                </RouterLink>
                <RouterLink to={logged} style={{ textDecoration: 'none', color: 'inherit', fontSize: '1.2rem', marginTop: '10px' }}>
                    {usr}
                </RouterLink>
            </Toolbar>
        </AppBar>
    );
}